import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  padding-left: 2rem;
`;
